module.exports = __webpack_public_path__ + "d3ee2fdc380f05b165b57f9c7b9f6be8.ttf";


//////////////////
// WEBPACK FOOTER
// ./assets/Lato-SemiboldItalic.ttf
// module id = 1014
// module chunks = 0